import { SET_CATEGORY } from "./mutations";

const initialState = {
  categorySelection: null,
};

const categoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CATEGORY:
      return { ...state, categorySelection: payload };
      
    default:
      return state;
  }
};

export default categoryReducer;
